var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNutShape = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "setting"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7986 1.13872L47.7077 20.8613C48.0974 21.5659 48.0974 22.4341 47.7077 23.1387L36.7986 42.8613C36.4088 43.5659 35.6886 44 34.9091 44H13.0909C12.3114 44 11.5912 43.5659 11.2014 42.8613L0.292309 23.1387C-0.0974363 22.4341 -0.0974363 21.5659 0.292309 20.8613L11.2014 1.13872C11.5912 0.434094 12.3114 2.06694e-05 13.0909 0H34.9091C35.6886 2.06694e-05 36.4088 0.434094 36.7986 1.13872ZM14.3497 39.445H33.6501L43.3003 21.9998L33.6501 4.55469H14.3497L4.69946 21.9998L14.3497 39.445Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2727 22.0004C15.2727 16.9692 19.18 12.8906 24 12.8906C28.8199 12.8906 32.7273 16.9692 32.7273 22.0004C32.7273 27.0315 28.8199 31.1101 24 31.1101C19.18 31.1101 15.2727 27.0315 15.2727 22.0004ZM19.6365 22.0002C19.6365 24.5158 21.5901 26.555 24.0001 26.555C26.4101 26.555 28.3638 24.5158 28.3638 22.0002C28.3638 19.4846 26.4101 17.4453 24.0001 17.4453C21.5901 17.4453 19.6365 19.4846 19.6365 22.0002Z",
    fill: "#4A4A4A"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNutShape);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nutShape.0938c94c2ef083347c169d068e73d0cd.svg";